<div class="gap-2 p-2 flex flex-col w-full overflow-hidden bg-white rounded-xl" style="height: calc(100vh - 60px);">
   <!-- Top Row: Chart & Store Summary -->
   <div class="grid grid-cols-1 lg:grid-cols-3 gap-2" style="height: 320px;">
      <!-- Weekly Sales Statistics -->
      <div class="lg:col-span-2 p-1 bg-white rounded-xl border border-gray-200 shadow-sm relative">
         <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-4">
            <h3 class="fs-18 font-bold text-gray-800">{{ 'DASHBSTR0001' | translate }}</h3>
            <div class="flex items-center gap-4">
               <div class="flex items-center gap-x-4 fs-14">
                  <div class="flex items-center gap-1.5">
                     <span class="w-3 h-1" style="background-color: #f87171;"></span> <span class="text-gray-600">{{
                        'DASHBSTR0018' | translate }}</span>
                  </div>
                  <div class="flex items-center gap-1.5">
                     <span class="w-3 h-1" style="background-color: #60a5fa;"></span> <span class="text-gray-600">{{
                        'DASHBSTR0017' | translate }}</span>
                  </div>
                  <div class="flex items-center gap-1.5">
                     <span class="w-3 h-1" style="background-color: #fbbf24;"></span> <span class="text-gray-600">{{
                        'DASHBSTR0019' | translate }}</span>
                  </div>
               </div>
               <div class="flex items-center justify-end gap-2">
                  <div class="flex gap-2">
                     <button (click)="changeWeek('sales', 'prev')"
                        class="w-10 h-10 bg-blue-500 text-white flex items-center justify-center rounded hover:bg-blue-600 transition-all shadow-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                           stroke="currentColor" class="w-4 h-4">
                           <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                        </svg>
                     </button>
                     <div
                        class="text-center flex items-center h-10 font-bold fs-16 text-gray-800 tracking-tight bg-gray-50 rounded border border-gray-100 mx-auto w-fit px-2">
                        {{ weeklySales.start | date:'yyyy-MM-dd' }} ~ {{ weeklySales.end | date:'yyyy-MM-dd' }}
                     </div>
                     <button (click)="changeWeek('sales', 'next')"
                        class="w-10 h-10 bg-blue-500 text-white flex items-center justify-center rounded hover:bg-blue-600 transition-all shadow-sm px-2 py-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                           stroke="currentColor" class="w-4 h-4">
                           <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                        </svg>
                     </button>
                  </div>
               </div>
            </div>
         </div>
         <div #salesChart class="w-full"></div>
      </div>

      <!-- Store Summary -->
      <div class="flex flex-col gap-6">
         <div
            class="bg-gradient-to-br from-blue-600 to-indigo-800 rounded-xl text-white shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col relative overflow-hidden ring-1 ring-white/20 h-fit">
            <div class="absolute -top-10 -right-10 w-40 h-40 bg-white opacity-5 rounded-full blur-3xl"></div>
            <div class="absolute bottom-0 left-0 w-32 h-32 bg-blue-400 opacity-10 rounded-full blur-2xl"></div>

            <div class="flex justify-between items-center p-4 border-b border-white/10 relative z-10">
               <div class="flex items-center gap-2">
                  <h3 class="font-bold fs-18 text-blue-50">{{storeInfo.stR_NM }}</h3>
               </div>
            </div>

            <div class="flex-1 flex flex-col justify-between divide-y divide-white/10 relative z-10">
               <div class="flex flex-col p-4 flex-1 gap-1">
                  <span class="fs-14 text-blue-200">{{ 'DASHBSTR0003' | translate }}</span>
                  <span class="fs-18 font-bold tracking-tight">{{ storeSummary()?.avgpay | number}}</span>
               </div>
               <div class="flex flex-col p-4 flex-1 gap-1">
                  <div class="flex justify-between items-baseline">
                     <span class="fs-14 text-blue-200">{{ 'DASHBSTR0004' | translate }}</span>
                  </div>
                  <span class="fs-18 font-bold tabular-nums tracking-tight">{{ storeSummary()?.yeS_PAY |number
                     }}</span>
               </div>
               <div class="flex flex-col p-2 flex-1 bg-black/20 backdrop-blur-sm">
                  <div class="flex justify-between items-end">
                     <div>
                        <span class="fs-14 text-blue-200 uppercase tracking-wider mb-1 block">{{
                           'DASHBSTR0005' | translate }}</span>
                        <span class="fs-18 font-bold text-yellow-300 tabular-nums drop-shadow-sm">{{
                           storeSummary()?.paY_AMT | number}}</span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>

   <!-- Middle Row: Popular Items & Reservation Stats -->
   <div class="grid grid-cols-2 gap-2" style="height: calc(100vh - 380px)">
      <div class="grid grid-rows-2 gap-2 h-full">
         <!-- Popular Items -->
         <div>
            <div
               class="bg-white p-2 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-300 h-full">
               <div class="flex items-center justify-end gap-2">
                  <div class="flex gap-2">
                     <button (click)="changeWeek('popular', 'prev')"
                        class="w-10 h-10 bg-blue-500 text-white flex items-center justify-center rounded hover:bg-blue-600 transition-all shadow-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                           stroke="currentColor" class="w-4 h-4">
                           <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                        </svg>
                     </button>
                     <div
                        class="text-center flex items-center h-10 font-bold fs-16 text-gray-800 tracking-tight bg-gray-50 rounded border border-gray-100 mx-auto w-fit px-2">
                        {{weekPopular.start | date:'yyyy-MM-dd'}} ~ {{weekPopular.end | date:'yyyy-MM-dd'}}
                     </div>
                     <button (click)="changeWeek('popular', 'next')"
                        class="w-10 h-10 bg-blue-500 text-white flex items-center justify-center rounded hover:bg-blue-600 transition-all shadow-sm px-2 py-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                           stroke="currentColor" class="w-4 h-4">
                           <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                        </svg>
                     </button>
                  </div>
               </div>

               <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:divide-x divide-gray-100">
                  <!-- Services Column -->
                  <div class="sm:pr-2">
                     <h4 class="font-bold text-gray-800 mb-2 text-base flex items-center gap-2">
                        <span class="w-2 h-2 rounded-full bg-indigo-500"></span>
                        {{ 'DASHBSTR0006' | translate }}
                     </h4>
                     <ul class="space-y-2" *ngFor="let item of popularServices()">
                        <li
                           class="flex items-center justify-between text-gray-700 p-1 rounded hover:bg-gray-50 transition-colors">
                           <div class="flex items-center gap-2">
                              <!-- <span class="font-bold text-xs w-5 h-5 flex items-center justify-center rounded"
                                 [class.bg-yellow-100]="i === 0" [class.text-yellow-700]="i === 0"
                                 [class.bg-gray-200]="i === 1" [class.text-gray-700]="i === 1"
                                 [class.bg-orange-100]="i === 2" [class.text-orange-800]="i === 2">{{ item.rank
                                 }}</span> -->
                              <span class="font-medium text-sm">{{ item.servicE_NM }}</span>
                           </div>
                           <span class="font-bold text-indigo-600 tabular-nums">{{ item.totalcnt }}</span>
                        </li>
                     </ul>
                  </div>
                  <!-- Options Column -->
                  <div class="sm:pr-2">
                     <h4 class="font-bold text-gray-800 mb-2 text-base flex items-center gap-2">
                        <span class="w-2 h-2 rounded-full bg-indigo-500"></span>
                        {{ 'DASHBSTR0007' | translate }}
                     </h4>
                     <ul class="space-y-2" *ngFor="let item of popularOptions()">
                        <li
                           class="flex items-center justify-between text-gray-700 p-1 rounded hover:bg-gray-50 transition-colors">
                           <div class="flex items-center gap-2">
                              <!-- <span class="font-bold text-xs w-5 h-5 flex items-center justify-center rounded"
                                 [class.bg-yellow-100]="i === 0" [class.text-yellow-700]="i === 0"
                                 [class.bg-gray-200]="i === 1" [class.text-gray-700]="i === 1"
                                 [class.bg-orange-100]="i === 2" [class.text-orange-800]="i === 2">{{ item.rank
                                 }}</span> -->
                              <span class="font-medium text-sm">{{ item.servicE_NM }}</span>
                           </div>
                           <span class="font-bold text-indigo-600 tabular-nums">{{ item.totalcnt }}</span>
                        </li>
                     </ul>
                  </div>
               </div>
            </div>
         </div>

         <!-- Weekly Reservation Stats -->
         <div>
            <div
               class="bg-white p-2 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-300 h-full">
               <div class="flex justify-between items-center mb-4">
                  <div class="flex items-center gap-2">
                     <h3 class="text-xl font-bold text-gray-800">{{ 'DASHBSTR0008' | translate }}</h3>
                  </div>
                  <div class="flex items-center justify-end gap-2">
                     <div class="flex gap-2">
                        <button (click)="changeWeek('reservation', 'prev')"
                           class="w-10 h-10 bg-blue-500 text-white flex items-center justify-center rounded hover:bg-blue-600 transition-all shadow-sm">
                           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                              stroke="currentColor" class="w-4 h-4">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                           </svg>
                        </button>
                        <div
                           class="text-center flex items-center h-10 font-bold fs-16 text-gray-800 tracking-tight bg-gray-50 rounded border border-gray-100 mx-auto w-fit px-2">
                           {{weekReservation.start | date:'yyyy-MM-dd'}} ~ {{weekReservation.end | date:'yyyy-MM-dd'}}
                        </div>
                        <button (click)="changeWeek('reservation', 'next')"
                           class="w-10 h-10 bg-blue-500 text-white flex items-center justify-center rounded hover:bg-blue-600 transition-all shadow-sm px-2 py-2">
                           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                              stroke="currentColor" class="w-4 h-4">
                              <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                           </svg>
                        </button>
                     </div>
                  </div>
               </div>
               <!-- 
               <div
                  class="text-center font-bold text-lg text-gray-800 mb-2 tracking-tight bg-gray-50 py-2 rounded border border-gray-100 mx-auto w-fit px-2">
                  2020-12-01 ~ 2025-12-07
               </div> -->

               <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  <div
                     class="bg-gradient-to-br from-indigo-50 to-white border border-indigo-100 p-2 rounded-xl flex flex-col items-center justify-center shadow-sm relative overflow-hidden group">
                     <div
                        class="absolute top-0 right-0 w-16 h-16 bg-indigo-100 rounded-bl-full opacity-50 transition-transform group-hover:scale-110">
                     </div>
                     <span class="text-indigo-600 font-bold mb-2 uppercase tracking-wide text-sm">{{
                        'DASHBSTR0009' | translate }}</span>
                     <span
                        class="text-4xl font-extrabold text-gray-900 border-b-2 border-indigo-200 pb-1 mb-2 tabular-nums group-hover:text-indigo-700 transition-colors">{{
                        reservationStats()?.revcnt | number}}</span>
                     <div
                        class="flex items-center text-xs font-medium text-gray-500 gap-2 bg-white px-2 py-1 rounded-full border border-gray-100 shadow-sm">
                        <span>{{ 'DASHBSTR0015' | translate }} {{ reservationStats()?.nrev | number }}</span>
                        @if(reservationStats()?.revcnt > reservationStats()?.nrev){
                        <span class="text-green-500 flex items-center">▲ {{ reservationStats()?.revrate
                           }}%</span>
                        }
                        @else{<span class="text-red-500 flex items-center">▲ {{ reservationStats()?.revrate
                           }}%</span>}
                     </div>
                  </div>
                  <div
                     class="bg-gradient-to-br from-red-50 to-white border border-red-100 2xl:p-6 p-2 rounded-xl flex flex-col items-center justify-center shadow-sm relative overflow-hidden group">
                     <div
                        class="absolute top-0 right-0 w-16 h-16 bg-red-100 rounded-bl-full opacity-50 transition-transform group-hover:scale-110">
                     </div>
                     <span class="text-red-600 font-bold mb-2 uppercase tracking-wide text-sm">{{
                        'DASHBSTR0010' | translate }}</span>
                     <span
                        class="text-4xl font-extrabold text-gray-900 border-b-2 border-red-200 pb-1 mb-3 tabular-nums group-hover:text-red-700 transition-colors">{{
                        reservationStats()?.cnccnt | number }}</span>
                     <div
                        class="flex items-center text-xs font-medium text-gray-500 gap-2 bg-white px-2 py-1 rounded-full border border-gray-100 shadow-sm">
                        <span>{{ 'DASHBSTR0015' | translate }} {{ reservationStats()?.ncnc | number }}</span>
                        @if(reservationStats()?.cnccnt > reservationStats()?.ncnc){
                        <span class="text-green-500 flex items-center">▲ {{ reservationStats()?.cncate
                           }}%</span>
                        }
                        @else{<span class="text-red-500 flex items-center">▲ {{ reservationStats()?.cncate
                           }}%</span>}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Bottom Row: Notices -->
      <div class="grid grid-cols-1 overflow-hidden gap-2" style="height: calc(100vh - 390px)">
         <div
            class="bg-white p-2 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-300"
            style="height: calc(100vh - 390px)">
            <div class="flex items-center justify-between gap-2 mb-4">
               <div class="flex items-center gap-2">
                  <h3 class="font-bold text-gray-800">{{ 'DASHBSTR0012' | translate }}</h3>
               </div>
               <!-- <div>
                  <button class="bg-gray-600 px-2 h-[37px] text-white hover:bg-gray-700 rounded-lg">{{'DASHBSTR0003' |
                     translate}}</button>
               </div> -->
            </div>
            <div class="overflow-auto rounded-lg h-[calc(100%-30px)]">
               <app-material-table [headers]="noticeHeaders()" [data]="notices()" [width]="'w-full'" [key]="'boarD_SEQ'"
                  [rowTemplate]="noticeRowTpl"></app-material-table>
               <ng-template #noticeRowTpl let-notice>
                  <tr class="hover:bg-gray-50 transition-colors group cursor-pointer"
                     (click)="getDetailst(notice); $event.stopPropagation()">
                     <!-- <td class="px-2 cursor-pointer text-center border-r border-b  w-4 p-[0.4rem]"
                        (click)="getDetailst(notice); $event.stopPropagation()">
                        <i class="pi fs-10" [class]="expandedRow == notice.boarD_SEQ ? 'pi-minus' : 'pi-plus'">
                        </i>
                     </td> -->
                     <td class="px-2 text-center border-r border-b w-24 p-[0.4rem]">
                        {{notice.boarD_SEQ}}</td>
                     <td class="px-2 border-r border-b text-left p-[0.4rem]">
                        {{notice.boarD_TITLE}}</td>
                     <td class="px-2 text-center border-r border-b p-[0.4rem]">{{notice.inserT_DT}}</td>
                  </tr>
                  <!-- @if (expandedRow === notice.boarD_SEQ) {
                  <tr>
                     <td colspan="4" class="text-left">
                        <div [innerHTML]="safeContentMap.get(notice.boarD_SEQ)" class="ql-editor">
                        </div>
                        <div class="grid grid-cols-3 gap-1 mt-2">
                           <div class="w-full" *ngFor="let item of notice.files; let i = index">
                              <div class="item flex items-center gap-1 cursor-pointer border p-1 rounded"
                                 (click)="review(item)">
                                 <ng-container [ngSwitch]="item.kind">

                                    <img *ngSwitchCase="'image'" [src]="item.previewUrl"
                                       class="object-cover rounded h-7 w-7">

                                    <video *ngSwitchCase="'video'" [src]="item.previewUrl"
                                       class="object-cover rounded h-7 w-7" muted controls>
                                    </video>

                                    <i class="fs-26 pi pi-file-pdf" *ngSwitchCase="'pdf'"></i>

                                    <i class="fs-26 pi pi-file-word" *ngSwitchCase="'docx'"></i>

                                    <i class="fs-26 pi pi-file-excel" *ngSwitchCase="'excel'"></i>

                                    <i class="fs-26 pi pi-file" *ngSwitchCase="'txt'"></i>

                                    <i class="fs-26 pi pi-file" *ngSwitchDefault></i>

                                 </ng-container>

                                 <div class="info flex-1 text-ellipsis">
                                    <div class="text-ellipsis">
                                       {{ cleanName(item.name) }}
                                    </div>
                                 </div>
                              </div>

                           </div>
                        </div>
                     </td>
                  </tr>
                  } -->
               </ng-template>
            </div>
         </div>
      </div>
   </div>
</div>

@if(loading){
<div class="loading-overlay">
   <div class="loader"></div>
</div>
}

<div *ngIf="openNoticeDetail()">
   <components-notice-detail [open]="openNoticeDetail()" (close)="openNoticeDetail.set(false)"
      [safeContentMap]="safeContentMap" [notice]="selectedNotice"></components-notice-detail>
</div>